export const AG_GRID_STATES_KEY = 'app.grid-states';